import produce from 'immer';
import {
  GET_PARTNER_CONFIGS,
  GET_PARTNER_CONFIGS_SUCCESS,
  GET_PARTNER_CONFIGS_FAILED,
  UPDATE_PARTNER_CONFIGS,
  UPDATE_PARTNER_CONFIGS_SUCCESS,
  UPDATE_PARTNER_CONFIGS_FAILED,
} from './constants';
// import {Actions, State} from './interfaces';

export const initialState: State = {
  partnerConfigs: {},
  loading: false,
  error: '',
};

export const NotificationsReducer = (state = initialState, action: Actions) =>
  produce(state, draft => {
    switch (action.type) {
      case GET_PARTNER_CONFIGS:
        draft.loading = true;
        break;
      case GET_PARTNER_CONFIGS_SUCCESS:
        // @ts-ignore
        draft.partnerConfigs = action.data;
        draft.loading = false;
        break;
      case GET_PARTNER_CONFIGS_FAILED:
        draft.error = action.error;
        draft.loading = false;
        break;
      case UPDATE_PARTNER_CONFIGS:
        draft.loading = true;
        break;
      case UPDATE_PARTNER_CONFIGS_SUCCESS:
        // @ts-ignore
        draft.providerList = action.data;
        draft.count = action.count;
        draft.inactiveCardCount = action.inactiveCardCount;
        draft.activeCardCount = action.activeCardCount;
        draft.loading = false;
        break;
      case UPDATE_PARTNER_CONFIGS_FAILED:
        draft.error = action.error;
        draft.loading = false;
        break;
      default:
        break;
    }
  });

export default NotificationsReducer;
